import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'

import { TooltipProvider } from '@/components/ui/tooltip'

import store from './store'
import history from './history'
import App from './containers/App/index'
import ErrorBoundary from './containers/ErrorBoundary'
import GlobalErrorToast from './containers/GlobalErrorToast'

import './index.css'

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <Router history={history}>
      <TooltipProvider delayDuration={200}>
        <ErrorBoundary>
          <App />
          <GlobalErrorToast />
        </ErrorBoundary>
      </TooltipProvider>
    </Router>
  </Provider>
)
